import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { rolesTypes } from "../constantes/actionTypes"

export const rolesActions = {
    getRoles: () => (
        createMiddlewareAction({
            successType: rolesTypes.GET_ALL_ROLES_SUCCESS,
            failureType: rolesTypes.GET_ALL_ROLES_FAILURE,
            method: "GET",
            endpoint: endpoints.ALL_ROLES
        })
    ),
}